import { styled } from "stitches.config";
import TextShadow from "../TextShadow";
import Typography from "../sushi/Typography";
import { useIntl } from "react-intl";
import Link from 'next/link';
import Button from "../sushi/Button";
import * as $segment from '@/utils/segment';

export type SimulatorActionBlockProps = {
    utmCampaign: string;
}

export const SimulatorActionBlock = ({utmCampaign}: SimulatorActionBlockProps) => {
    const { formatMessage } = useIntl();

    const params = new URLSearchParams({
        utm_source: 'simulators',
        utm_medium: 'tools',
        utm_campaign: utmCampaign,
        utm_content: 'cta'
    })

    const handleCtaClick = () => {
        $segment.event('simulator_cta_clicked', { simulator: utmCampaign });
    };

    return (
      <ActionWrapper>
        <ActionBlock>
          <ActionBlockText>
            <Typography variant="headingXXS" as={TextShadow} center>
              {formatMessage({ id: 'wealth_simulator.action.title' })}
            </Typography>
            <Typography variant="bodyM" color="secondaryAlt" center>
              {formatMessage({ id: 'wealth_simulator.action.subtitle' })}
            </Typography>
          </ActionBlockText>
          <span>
            <Link href={`https://app.finary.com/v2/signup?${params.toString()}`} passHref>
              <Button as="a" variant="tertiaryDark" onClick={handleCtaClick}>
                {formatMessage({ id: 'wealth_simulator.action.cta' })}
              </Button>
            </Link>
          </span>
        </ActionBlock>
      </ActionWrapper>
    )
}

const ActionWrapper = styled('section', {
    '@sm': {
      padding: '1px',
      background: '$colorGradientDarkX',
      borderRadius: '16px',
      marginRight: '$8',
      marginLeft: '$8',
      marginBottom: '$6'
    },
  });
  
  const ActionBlock = styled('div', {
    display: 'flex',
    padding: '$10',
    gap: '$6',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '@sm': {
    padding: '$8',
      borderRadius: '16px',
      backgroundColor: 'black',
    },
  });

  const ActionBlockText = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$3',
  });